import { FC } from "react";

import classes from "./DonoTrainGoalsBox.module.scss";
import { AilenaxBox } from "../AilenaxBox/AilenaxBox";
import { DonoTrainSettings } from "@ailenax-overlay/shared";
import classNames from "classnames";

interface DonoTrainGoalsBoxProps {
    settings: DonoTrainSettings;
    visible: boolean;
}

export const DonoTrainGoalsBox: FC<DonoTrainGoalsBoxProps> = ({ settings, visible }) => {
    return (
        <AilenaxBox className={classNames(classes.container, visible && classes.shown)}>
            <div className={classes.title}>Donation-Train Goals</div>
            <ul className={classes.goals}>
            { settings.goals.map((goal) => (
                <li key={`${goal.level}-${goal.goal}`} className={classes.goal}>
                    <span className={classes.level}>Level {goal.level}:</span> <span className={classes.goalTitle}>{goal.goal}</span>
                </li>
            ))}
            </ul>
        </AilenaxBox>
    );
}